import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ServerRootService } from '@se/se.ui.html5';
import { catchError, Observable, throwError } from "rxjs";
import { AuditRequest } from "./audit-request";

@Injectable({
    providedIn: 'root',
})

export class AuditClientService extends ServerRootService {

    private readonly endPoint = '/Vna/BrokerAudit';
    private readonly url = this.getServerRoot() + this.endPoint;

    constructor(private httpClient: HttpClient) {
        super();
    }

    auditDicom(request: AuditRequest): Observable<any> {
        return this.httpClient.post(
            this.url,
            request
        ).pipe(
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.status === 0) {
            console.error('An error occurred:', error.error);
        } else {
            console.error(
                `Backend returned code ${error.status}, body was: `, error.error);
        }
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
